import { render, staticRenderFns } from "./CourseViewUserPermissionsCard.vue?vue&type=template&id=c6567960&scoped=true&"
import script from "./CourseViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./CourseViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseViewUserPermissionsCard.vue?vue&type=style&index=0&id=c6567960&lang=scss&scoped=true&"
import style1 from "./CourseViewUserPermissionsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6567960",
  null
  
)

export default component.exports